import { FormattedMessage } from 'react-intl'
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons'

import { Alert } from 'Components/_theme'

import { LIST_FILTERS_UNAVAILABLE_ALERT } from './ListFiltersUnavailableAlert.constants'
import type { ListFiltersUnavailableAlertProps } from './ListFiltersUnavailableAlert.types'

export const ListFiltersUnavailableAlert = (
  props: ListFiltersUnavailableAlertProps,
) => {
  const { messageId = 'ListFiltersUnavailableAlert_text' } = props

  return (
    <Alert
      className="mb-4"
      data-testid={LIST_FILTERS_UNAVAILABLE_ALERT}
      iconLeft={faCircleExclamation}
      variant="warning"
    >
      <FormattedMessage id={messageId} />
    </Alert>
  )
}
